import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import {
  UserModel,
  UserService,
} from '@lib/gc-common';

@Component({
  selector: 'mip-profile-list-profiles',
  templateUrl: './profile-list-profiles.component.html',
  styleUrls: ['./profile-list-profiles.component.scss'],
})
export class ProfileListProfilesComponent implements OnInit, OnChanges {
  @Input() profiles: Array<UserModel> = [];
  @Input() loading = true;

  @Output() onReachingBottom = new EventEmitter();

  isAuthenticated = false;

  constructor(private userService: UserService) {
    this.isAuthenticated = this.userService.isAuthenticated();
  }

  async ngOnInit() {
    try {
    } catch (e) {
      throw e;
    }
  }

  ngOnChanges() {
    // console.log('profile-followers.component->ngOnChanges(): this.loading', this.loading);
    // console.log('profile-followers.component->ngOnChanges(): this.profiles', this.profiles);
  }

  _onReachingBottom() {
    // console.log('profile-followers.component->_onReachingBottom()');
    this.onReachingBottom.emit();
  }
}
